import {collection, field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {SurchargeReportSelectionData} from "../../../pricing/surcharge/controls/surcharge-report-selection-control.component";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";
import {DiscountReportSelectionData} from "../../../pricing/discount/controls/discount-report-selection-control.component";
import {
    EntityGroupByReportCriteriaComponent
} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";

export class DiscountAuditReportData extends ReportData<DiscountAuditReportData> {
    @field reportType: string = EntityGroupByReportCriteriaComponent.DISCOUNT_VALUE;
    @field summary: boolean = true;
    @collection() groupBy: string[] = ["none"];
    @collection(SurchargeReportSelectionData) surcharges: SurchargeReportSelectionData[];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @collection(DiscountReportSelectionData) discounts: DiscountReportSelectionData[];
}
